module.exports = __webpack_public_path__ + "static/media/icon-copy.6aa495e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-copy.svg
// module id = 431
// module chunks = 7